// Ink and paper for the canvas (CLAUDE.md rule 3: two colors only, night swaps them).
// The UI reads the live CSS tokens and hands them over, so canvas and chrome always match.
export type Ink = {
  ink: string;
  paper: string;
  /** Font family for map labels. */
  font: string;
};

export const DAY: Ink = {
  ink: '#161616',
  paper: '#f5f3ee',
  font: "'IBM Plex Mono', ui-monospace, monospace",
};

export const NIGHT: Ink = {
  ink: '#ebe8e1',
  paper: '#121212',
  font: DAY.font,
};
